/* eslint-disable */ 
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { Howl } from 'howler';

import styles from './ImageMode.module.css';

import { ImageModeContext } from './ImageModeContext.js';

import SinglePageSpread from './SinglePageSpread';
import DoublePageSpread from './DoublePageSpread';
import { useContext } from 'react';
import { overWriteStyleProperties } from '../../../services/Api';
import { Article } from '../../../components/canvasflow/article/Article';
import { AppContext } from '../../../services/AppContext';
import imgLogo from '../../../components/navbar/logo.png';
import { Link } from 'react-router-dom';
import { Player } from '../../../services/Player';
import { useEffect } from 'react';

export default class ImageMode extends React.Component {
	static contextType = AppContext;

	state = {
		hideLeftArticle: true,
		hideRightArticle: true,
		selectedArticle: null,
		isArticleHorizontalExpanded: false,
		isArticleVerticalExpanded: false,
		article: null,
		currentPage: null,
		totalOfPages: null,
		events: {},
		player: null,
		fontSize: 62.5,
		pages: null,
		doublePages: null,
		isFavorite: false,
	};

	componentDidMount() {
		const { article } = this.props;
		let fontSize = 62.5;

		if (localStorage.getItem('fontSize')) {
			try {
				fontSize = parseFloat(localStorage.getItem('fontSize'));
			} catch (e) {
				console.error(e);
			}
		}
		this.setState({
			article,
			fontSize,
			articleMap: this.getArticlesMap(),
		});
		this.getPlayer(article);

		const pages = this.getPages();
		const doublePages = this.getDoublePages();

		this.setState({
			pages,
			doublePages
		});

		document.removeEventListener('keydown', this.onKeydown, false);
		document.addEventListener('keydown', this.onKeydown, false);
	}

	getPages = () => {
		const { issue } = this.props;

		const imagesUrlMap = this.getImagesUrlMap();
		const pages = JSON.parse(JSON.stringify(issue.pages));
		return pages.reduce(
			(acc, page) => {
				page.articles = this.getPageArticles(page);
				page.article = page.articles?.[0]?.ArticleID;
				page.image = imagesUrlMap.get(page.page);
				acc.push(page);
				return acc;
			},
			[]
		);
	};

	getDoublePages = () => {
		const { issue } = this.props;
		const imagesUrlMap = this.getImagesUrlMap();

		const pages = JSON.parse(JSON.stringify(issue.pages));

		const doublePages = pages.reduce(
			(acc, page, i) => {
				page.articles = this.getPageArticles(page);
				page.article = page.articles?.[0]?.ArticleID;
				page.image = imagesUrlMap.get(page.page);
				if (!i) {
					acc[acc.length - 1].push(page);
					return acc;
				}

				const lastIndex = acc.length - 1;

				const lastValue = acc[lastIndex];
				if (lastValue.length == 2) {
					acc.push([page]);
					return acc;
				}

				lastValue.push(page);
				acc[lastIndex] = lastValue;

				return acc;
			},
			[[null]]
		);
		return doublePages;
	};

	componentDidUpdate(prevProps) {
		const { lang, article } = this.props;
		const { player } = this.state;
		if (prevProps.lang !== lang) {
			if (player) {
				player.close();
			}
			this.setState({ player: null });
			this.getPlayer(article);
		}
	}

	getPlayer = (article) => {
		const { tts } = this.context;
		const { lang } = this.props;
		if (!tts?.enabled || !article || !article?.audio) {
			return;
		}
		const { audio } = article;
		const audioUrl = `${audio}/${lang}.mp3`;

		const setPlayer = (player) => {
			this.setState({ player });
		};

		const sound = new Howl({
			src: [audioUrl],
			volume: 0.7,
			html5: true,
			onload: () => {
				if (sound) {
					setPlayer(new Player(sound));
				}
			},
			onloaderror: () => {
				console.error(`Could not load: ${audioUrl}`);
				setPlayer(null);
			},
		});
	};

	onKeydown = (event) => {
		const { selectedArticle } = this.state;
		const { keyCode } = event;

		const LEFT_ARROW = 37;
		const RIGHT_ARROW = 39;

		if (keyCode === LEFT_ARROW) {
			if (selectedArticle) return;
			this.sendEvent('prev-article');
			return;
		}

		if (keyCode === RIGHT_ARROW) {
			if (selectedArticle) return;
			this.sendEvent('next-article');
			return;
		}
	};

	onChangeFontSize = (fontSize) => {
		localStorage.setItem('fontSize', fontSize);
		this.setState({ fontSize });
	};

	onChangePage = ({ article, currentPage, totalOfPages }) => {
		if (article) {
			this.setState({ article });
		}
		if (currentPage) {
			this.setState({ currentPage });
		}
		if (totalOfPages) {
			this.setState({ totalOfPages });
		}
	};

	getArticlesMap = () => {
		const { articles } = this.props;
		const articlesMap = new Map();
		for (const article of articles) {
			articlesMap.set(`${article.ArticleID}`, article);
		}
		return articlesMap;
	};

	onImageClick = (article, direction) => {
		const { db } = this.context;
		const { selectedArticle } = this.state;
		if (selectedArticle) return;

		this.getPlayer(article);

		db.isFavorite(article.id).then((isFavorite) =>
			this.setState({ isFavorite })
		);

		if (direction === 'left') {
			this.setState({
				selectedArticle: article,
				hideLeftArticle: true,
				hideRightArticle: false,
			});
		} else if (direction === 'right') {
			this.setState({
				hideLeftArticle: false,
				selectedArticle: article,
				hideRightArticle: true,
			});
		}
	};

	onCloseSelectedArticle = () => {
		this.setState({
			hideLeftArticle: true,
			hideRightArticle: true,
			selectedArticle: null,
			isArticleHorizontalExpanded: false,
			isArticleVerticalExpanded: false,
		});
	};
	onHorizontalExpandClick = () => {
		this.setState({ isArticleHorizontalExpanded: true });
	};
	onHorizontalCollapseClick = () => {
		this.setState({ isArticleHorizontalExpanded: false });
	};
	onVerticalExpandClick = () => {
		this.setState({ isArticleVerticalExpanded: true });
	};
	onVerticalCollapseClick = () => {
		this.setState({ isArticleVerticalExpanded: false });
	};
	onArticleChange = (article) => {
		const { selectedArticle } = this.state;
		const { onArticleChange } = this.props;
		if (selectedArticle) return;
		onArticleChange(article);
		setTimeout(() => {
			this.setState({
				hideLeftArticle: true,
				hideRightArticle: true,
				selectedArticle: null,
				isArticleHorizontalExpanded: false,
				isArticleVerticalExpanded: false,
				article,
			});
		}, 300);
	};

	sendEvent = (name, data) => {
		const { events } = this.state;
		if (events[name]) {
			events[name](data);
		}
	};

	removeEvent = (name) => {
		const { events } = this.state;
		if (events[name]) {
			delete events[name];
		}

		this.setState({ events });
	};

	subscribeEvent = (name, fn) => {
		const { events } = this.state;
		if (!events[name]) {
			events[name] = fn;
			this.setState({ events });
		}
	};

	onIsFavoriteClick = () => {
		const { db, tracking } = this.context;
		const { selectedArticle, isFavorite } = this.state;
		if (!isFavorite) {
			db.saveFavorite(selectedArticle.id).then(() => {
				tracking.event({
					category: 'User',
					action: 'Add article to bookmark',
				});
				this.setState({ isFavorite: true });
			});
		} else {
			db.removeFavorite(selectedArticle.id).then(() => {
				tracking.event({
					category: 'User',
					action: 'Remove article from bookmark',
				});
				this.setState({ isFavorite: false });
			});
		}
	};

	componentWillUnmount() {
		const { player } = this.state;
		if (player) {
			player.close();
		}
		this.setState({ selectedArticle: null, player: null });
		document.removeEventListener('keydown', this.onKeydown, false);
	}

	getPageArticles = (page) => {
		const articleMap = this.getArticlesMap();
		const articles = [];
		// The page do not have an article associated so we know its an advert
		if (!page.articles) {
			const articleFromPage = this.getArticleFromPage(page.page);
			if (articleFromPage) {
				const { ArticleID, id } = articleFromPage;
				articles.push({
					id: id,
					ArticleID,
					isAdvert: true,
					blocks: null,
				});
			}

			return articles;
		}

		for (const ArticleID in page.articles) {
			const blocks = page.articles[ArticleID];
			const article = articleMap.get(ArticleID);
			if (article) {
				const { id, index } = article;
				articles.push({
					id: id,
					ArticleID,
					index,
					blocks,
				});
			}
		}

		return articles.sort((a, b) => a - b);
	};

	getArticleFromPage = (pageId) => {
		const { articles } = this.props;
		for (const article of articles) {
			if (article?.pages?.length) {
				for (const page of article.pages) {
					if (page.split('/').pop() === pageId) {
						return article;
					}
				}
			}
		}
		return null;
	};

	getImagesUrlMap = () => {
		const { articles } = this.props;
		return articles.reduce((acc, article) => {
			for (const page of article.pages) {
				acc.set(page.split('/').pop(), page);
			}
			return acc;
		}, new Map());
	};

	render() {
		const { device, width } = this.context;
		const {
			articles,
			issue,
			imagesMap,
			lang,
			componentStyles,
			onLanguageSelected,
		} = this.props;
		const {
			article,
			hideLeftArticle,
			hideRightArticle,
			selectedArticle,
			isArticleHorizontalExpanded,
			isArticleVerticalExpanded,
			totalOfPages,
			currentPage,
			fontSize,
			player,
			isFavorite,
			articleMap,
			pages,
			doublePages
		} = this.state;
		if (!issue) {
			return null;
		}
		return (
			<ImageModeContext.Provider
				value={{
					article,
					articles,
					issue,
					width,
					imagesMap,
					lang,
					device,
					selectedArticle,
					isArticleHorizontalExpanded,
					isArticleSelected: !!selectedArticle,
					articleMap,
					onImageClick: this.onImageClick,
					onHorizontalCollapseClick: this.onHorizontalCollapseClick,
					onHorizontalExpandClick: this.onHorizontalExpandClick,
					onVerticalCollapseClick: this.onVerticalCollapseClick,
					onVerticalExpandClick: this.onVerticalExpandClick,
					mergeStyles,
					componentStyles,
					overwriteStyles,
					processComponents,
					onArticleChange: this.onArticleChange,
					onChangePage: this.onChangePage,
					onCloseSelectedArticle: this.onCloseSelectedArticle,
					currentPage,
					totalOfPages,
					fontSize,
					subscribeEvent: this.subscribeEvent,
					removeEvent: this.removeEvent,
					sendEvent: this.sendEvent,
					onChangeFontSize: this.onChangeFontSize,
					onLanguageSelected,
					onIsFavoriteClick: this.onIsFavoriteClick,
					isFavorite,
					player,
					getPageArticles: this.getPageArticles,
					getImagesUrlMap: this.getImagesUrlMap
				}}
			>
				<div className="App">
					<Header />
					<div className={styles['image-mode']}>
						<Navbar />
						<main>
							<div className={styles['pages']}>
								{device.type === 'mobile' ? (pages ? (
									<SinglePageSpread pages={JSON.parse(JSON.stringify(pages))} />
								) : null) : (doublePages ? (
									<DoublePageSpread pages={JSON.parse(JSON.stringify(doublePages))} />
								) : null)}
							</div>
							{!device.isTouchable ? (
								<NavigationArrow direction={'left'} />
							) : null}
							{!device.isTouchable ? (
								<NavigationArrow direction={'right'} />
							) : null}
							{device.type !== 'mobile' ? (
								<FloatingArticle
									hide={hideLeftArticle}
									article={selectedArticle}
									direction={'left'}
									isVerticalExpanded={
										isArticleVerticalExpanded
									}
									isHorizontalExpanded={
										!hideLeftArticle
											? isArticleHorizontalExpanded
											: false
									}
								/>
							) : null}
							<FloatingArticle
								hide={
									device.type === 'mobile' && selectedArticle
										? false
										: hideRightArticle
								}
								direction={'right'}
								article={selectedArticle}
								isVerticalExpanded={isArticleVerticalExpanded}
								isHorizontalExpanded={
									device.type === 'mobile' && selectedArticle
										? true
										: !hideRightArticle
											? isArticleHorizontalExpanded
											: false
								}
							/>
						</main>
					</div>
				</div>
			</ImageModeContext.Provider>
		);
	}
}

ImageMode.propTypes = {
	issue: PropTypes.object,
	article: PropTypes.object.isRequired,
	articles: PropTypes.array.isRequired,
	lang: PropTypes.string,
	imagesMap: PropTypes.object,
	componentStyles: PropTypes.object,
	onArticleChange: PropTypes.func,
	onLanguageSelected: PropTypes.func,
	isFavorite: PropTypes.bool.isRequired,
	onIsFavoriteClick: PropTypes.func.isRequired,
};

function Navbar() {
	const { currentPage, totalOfPages } = useContext(ImageModeContext);
	const { theme } = useContext(AppContext);
	const { navbar } = theme;

	return (
		<nav
			style={{
				background: navbar.background,
				color: navbar.color,
				userSelect: 'none',
			}}
		>
			<div>
				<Link to={'/'}>
					<button
						className={styles['back']}
						style={{ background: navbar.color }}
					/>
				</Link>
			</div>
			<Link to={'/'} className={styles['image']}>
				<img src={imgLogo} />
			</Link>
			<div>
				{currentPage && totalOfPages
					? `${currentPage} / ${totalOfPages}`
					: null}
			</div>
		</nav>
	);
}

function Header() {
	const { article, lang } = useContext(ImageModeContext);
	if (!article) {
		return null;
	}

	let title = '';
	if (article?.name && article?.name[lang]) {
		title = article?.name[lang];
	}

	const url = window.location.href;

	const { description, thumbnail } = article;

	return (
		<Helmet>
			{title ? <title>{title}</title> : null}
			{description ? (
				<meta name="description" content={description} />
			) : null}

			{title ? <meta itemProp="name" content={title} /> : null}
			{description ? (
				<meta itemProp="description" content={description} />
			) : null}
			{thumbnail ? <meta itemProp="image" content={thumbnail} /> : null}

			<meta property="og:url" content={url} />
			<meta property="og:type" content="website"></meta>
			{title ? <meta property="og:title" content={title} /> : null}
			{description ? (
				<meta property="og:description" content={description} />
			) : null}
			{thumbnail ? (
				<meta property="og:image" content={thumbnail} />
			) : null}

			<meta name="twitter:card" content="summary_large_image" />
			{title ? <meta name="twitter:title" content={title} /> : null}
			{description ? (
				<meta name="twitter:description" content={description} />
			) : null}
			{thumbnail ? (
				<meta name="twitter:image" content={thumbnail} />
			) : null}
		</Helmet>
	);
}

function FloatingArticle({
	hide,
	direction,
	isHorizontalExpanded,
	isVerticalExpanded,
	article,
}) {
	const { device } = useContext(AppContext);

	const [isSettingsOpen, setIsSettingOpen] = useState(false);
	const [isPlayerOpen, setIsPlayerOpen] = useState(false);
	const onPlayerClick = () => {
		setIsPlayerOpen(!isPlayerOpen);
	};
	const {
		onHorizontalExpandClick,
		onHorizontalCollapseClick,
		lang,
		onCloseSelectedArticle,
		onVerticalCollapseClick,
		onVerticalExpandClick,
	} = useContext(ImageModeContext);

	const name = article?.name[lang];

	let horizontalActionButton =
		device.type === 'mobile' ? null : isHorizontalExpanded ? (
			<button
				className={styles['collapse-horizontal-icon']}
				onClick={onHorizontalCollapseClick}
			/>
		) : (
			<button
				className={styles['expand-horizontal-icon']}
				onClick={onHorizontalExpandClick}
			/>
		);

	let verticalActionButton = isVerticalExpanded ? (
		<button
			className={styles['collapse-vertical-icon']}
			onClick={onVerticalCollapseClick}
		/>
	) : (
		<button
			className={styles['expand-vertical-icon']}
			onClick={onVerticalExpandClick}
		/>
	);

	return (
		<div
			className={`${styles[`${direction}-article`]} ${hide ? styles['hide'] : ''
				} ${isHorizontalExpanded ? styles['expand-horizontal'] : ''}
			${isVerticalExpanded ? styles['expand-vertical'] : ''}`}
		>
			<div className={`${styles['navbar']}`}>
				<div className={styles['actions']}>
					<button
						className={styles['close']}
						onClick={() => {
							setIsPlayerOpen(false);
							setTimeout(() => {
								setIsSettingOpen(false);

								onCloseSelectedArticle();
							}, 100);
						}}
					/>
					<button
						className={styles['settings-icon']}
						onClick={() => {
							setIsSettingOpen(!isSettingsOpen);
						}}
					/>
				</div>

				<div className={styles['article-name']}>{name}</div>
				<div className={styles['article-size-actions']}>
					{horizontalActionButton}
					{verticalActionButton}
				</div>
			</div>
			<ArticleContainer
				isPlayerOpen={isPlayerOpen}
				onPlayerClick={onPlayerClick}
				isSettingsOpen={isSettingsOpen}
				hide={hide}
			/>
		</div>
	);
}

FloatingArticle.propTypes = {
	hide: PropTypes.bool.isRequired,
	direction: PropTypes.string.isRequired,
	isHorizontalExpanded: PropTypes.bool.isRequired,
	isVerticalExpanded: PropTypes.bool.isRequired,
	article: PropTypes.object,
};

function ArticleContainer({ isSettingsOpen, hide, isPlayerOpen, onPlayerClick }) {
	const appContext = useContext(AppContext);
	const {
		lang,
		selectedArticle,
		player,
		fontSize,
	} = useContext(ImageModeContext);
	if (!selectedArticle) {
		return null;
	}

	const { id, index, style, components } = selectedArticle;

	return (
		<div id={`container-${id}`} className={styles['article-container']}>
			<ArticleSettings
				open={isSettingsOpen}
				onPlayerClick={onPlayerClick}
				isPlayerOpen={isPlayerOpen}
			/>
			<div
				className={styles['article']}
			>
				<Article
					id={id}
					index={index}
					lang={lang}
					style={`${style}`}
					fontSize={fontSize}
					styles={appContext.styles}
					components={components}
					onLightboxMode={222222}
				/>
			</div>
			{!hide && player ? (
				<PlayerComponent
					open={isPlayerOpen}
					player={player}
					article={selectedArticle}
				/>
			) : null}
		</div>
	);
}

ArticleContainer.propTypes = {
	isSettingsOpen: PropTypes.bool.isRequired,
	isPlayerOpen: PropTypes.bool.isRequired,
	hide: PropTypes.bool,
	onPlayerClick: PropTypes.func.isRequired,
};

function NavigationArrow({ direction }) {
	const {
		currentPage,
		totalOfPages,
		selectedArticle,
		sendEvent,
	} = useContext(ImageModeContext);
	if (!currentPage || !totalOfPages) {
		return null;
	}

	let onClick =
		direction === 'left'
			? () => {
				sendEvent('prev-article');
			}
			: () => {
				sendEvent('next-article');
			};

	let hide = !!selectedArticle;
	if (!hide) {
		if (direction === 'left' && currentPage === 1) {
			hide = true;
		}
		if (direction === 'right' && currentPage === totalOfPages) {
			hide = true;
		}
	}
	return (
		<div
			className={`${styles['navigation-arrow']} ${styles[direction]} ${hide ? styles['hide'] : ''
				}`}
			onClick={onClick}
		>
			<button />
		</div>
	);
}

NavigationArrow.propTypes = {
	direction: PropTypes.string.isRequired,
};

function ArticleSettings({ open, isPlayerOpen, onPlayerClick }) {
	return (
		<div
			className={`${styles['article-settings']} ${open ? '' : styles['hide']
				}`}
		>
			<ActionOptions
				onPlayerClick={onPlayerClick}
				isPlayerOpen={isPlayerOpen}
			/>
			<FontsOption />
			<LanguagesOption />
		</div>
	);
}

ArticleSettings.propTypes = {
	open: PropTypes.bool.isRequired,
	isPlayerOpen: PropTypes.bool,
	onPlayerClick: PropTypes.func,
};

function ActionOptions({ isPlayerOpen, onPlayerClick }) {
	const { isFavorite, onIsFavoriteClick, player } = useContext(
		ImageModeContext
	);
	const { config } = useContext(AppContext);

	const playerButton = isPlayerOpen ? (
		<div>
			<button
				className={styles['player-button-stop']}
				onClick={onPlayerClick}
			/>
		</div>
	) : (
		<div>
			<button
				className={styles['player-button-play']}
				onClick={onPlayerClick}
			/>
		</div>
	);
	if (!player && !config?.bookmarks?.enabled) {
		return null;
	}
	return (
		<div className={styles['action-options']}>
			{config?.bookmarks?.enabled ? (
				<div>
					<button
						onClick={onIsFavoriteClick}
						className={`${styles['bookmark-button']} ${isFavorite ? styles['selected'] : ''
							}`}
					/>
				</div>
			) : null}
			{player ? playerButton : null}
		</div>
	);
}

ActionOptions.propTypes = {
	isPlayerOpen: PropTypes.bool,
	onPlayerClick: PropTypes.func.isRequired,
};

function FontsOption() {
	const { fontSize, onChangeFontSize } = useContext(ImageModeContext);
	const minFontSize = 30;
	const maxFontSize = 90;
	const fontSizeStep = 10;
	const decreaseFontButton =
		fontSize > minFontSize ? (
			<div
				onClick={() => {
					const newFontSize = fontSize - fontSizeStep;
					if (newFontSize <= minFontSize) {
						onChangeFontSize(minFontSize);
						return;
					}
					onChangeFontSize(newFontSize);
				}}
			>
				<button className={styles['decrease-font-button']} />
			</div>
		) : (
			<div>
				<button className={styles['decrease-font-button']} disabled />
			</div>
		);
	const increaseFontButton =
		fontSize < maxFontSize ? (
			<div
				onClick={() => {
					const newFontSize = fontSize + fontSizeStep;
					if (newFontSize >= maxFontSize) {
						onChangeFontSize(maxFontSize);
						return;
					}
					onChangeFontSize(newFontSize);
				}}
			>
				<button className={styles['increase-font-button']} />
			</div>
		) : (
			<div>
				<button className={styles['increase-font-button']} disabled />
			</div>
		);
	return (
		<div className={styles['fonts']}>
			{decreaseFontButton}
			{increaseFontButton}
		</div>
	);
}

function LanguagesOption() {
	const { selectedArticle, lang, onLanguageSelected } = useContext(
		ImageModeContext
	);

	const { languages, mapLang } = useContext(AppContext);
	if (!selectedArticle) {
		return null;
	}
	if (!selectedArticle?.languages?.length) {
		return null;
	}

	const availableLanguages = selectedArticle.languages.filter((language) => {
		for (const l of languages) {
			if (l === language) {
				return true;
			}
		}
		return false;
	});
	if (availableLanguages.length <= 1) {
		return null;
	}

	return (
		<div className={styles['languages']}>
			{availableLanguages.map((language) => {
				const isSelected = language === lang;
				return (
					<div
						key={language}
						onClick={() => {
							onLanguageSelected(language);
						}}
						className={`${styles['language']} ${isSelected ? styles['selected'] : ''
							}`}
					>
						<h4>{mapLang(lang, language)}</h4>
						<span />
					</div>
				);
			})}
		</div>
	);
}

function PlayerComponent({ player, open, article }) {
	const { duration } = player;
	const [state, setState] = useState(player?.state);
	const [position, setPosition] = useState(player?.position);
	const updatePosition = (direction, seconds) => {
		if (direction === 'forward') {
			player.forward(seconds);
		} else {
			player.rewind(seconds);
		}
	};
	const onToggleClick = () => {
		player?.playPause();
	};
	useEffect(() => {
		if (!player) {
			return;
		}

		player.onChange('state', (s) => {
			setState(s);
		});
		player.onChange('position', (p) => {
			setPosition(p);
		});

		if (!article || !open) {
			setState('stop');
			player.stop();
			return;
		}

		if (article && open) {
			player.play();
			return;
		}
	}, [open, article]);

	return (
		<div className={`${styles['player']} ${open ? '' : styles['hide']}`}>
			<SmallPlayerComponent
				state={state}
				progress={(position * 100) / duration}
				onToggleClick={onToggleClick}
				updatePosition={updatePosition}
			/>
		</div>
	);
}

PlayerComponent.propTypes = {
	player: PropTypes.object.isRequired,
	open: PropTypes.bool.isRequired,
	article: PropTypes.object.isRequired,
};

function SmallPlayerComponent({
	state,
	onToggleClick,
	progress,
	updatePosition,
}) {
	const { selectedArticle } = useContext(ImageModeContext);
	const { thumbnail } = selectedArticle;
	return (
		<div className={styles['small-player-container']}>
			<div className={styles['content']}>
				<div className={styles['cover']}>
					<div>{thumbnail ? <img src={thumbnail} /> : null}</div>
				</div>
				<div className={styles['controls']}>
					<button
						onClick={() => {
							updatePosition('rewind', 30);
						}}
						className={styles['btn-rewind-30']}
					/>
					<button
						onClick={() => {
							updatePosition('rewind', 10);
						}}
						className={styles['btn-rewind-10']}
					/>

					<button
						onClick={onToggleClick}
						className={
							styles[
							`btn-${state === 'playing' ? 'pause' : 'play'}`
							]
						}
					/>
					<button
						onClick={() => {
							updatePosition('forward', 10);
						}}
						className={styles['btn-forward-10']}
					/>
					<button
						onClick={() => {
							updatePosition('forward', 30);
						}}
						className={styles['btn-forward-30']}
					/>
				</div>
				<div className={styles['expand']} style={{ display: 'none' }}>
					<button />
				</div>
			</div>
			<div className={styles['progress-bar']}>
				<div className={styles['base']} />
				<div
					className={styles['progress']}
					style={{ width: `${progress}%` }}
				/>
			</div>
		</div>
	);
}

SmallPlayerComponent.propTypes = {
	state: PropTypes.string.isRequired,
	progress: PropTypes.number.isRequired,
	onToggleClick: PropTypes.func.isRequired,
	updatePosition: PropTypes.func.isRequired,
};

function mergeStyles(article, styles, deviceType) {
	if (deviceType) {
		return mergeDeviceStyles(article, styles, deviceType);
	}
	return article.style;
}

function overwriteStyles(style, overwrite) {
	const response = {};
	const properties = { ...style, ...overwrite };
	for (const property in properties) {
		if (style[property] && overwrite[property]) {
			response[property] = { ...style[property], ...overwrite[property] };
		}

		if (overwrite[property] && !style[property]) {
			response[property] = overwrite[property];
		}

		if (!overwrite[property] && style[property]) {
			response[property] = style[property];
		}
	}
	return response;
}

function mergeDeviceStyles(article, styles, deviceType) {
	if (deviceType === 'mobile') {
		return article.style;
	} else if (deviceType !== 'desktop' && deviceType !== 'tablet') {
		return article.style;
	}

	if (!styles) {
		return null;
	}

	let style = getStyleByID(styles, article.StyleID);

	if (style && style[deviceType]) {
		let styleToMerge = getStyleByID(styles, style[deviceType]);
		if (!styleToMerge) {
			return article.style;
		}

		// Remove comment to use the snapshot
		style = article.style;
		return overWriteStyleProperties(style, styleToMerge);
	}

	return article.style;
}

function getStyleByID(styles, id) {
	return styles[id];
}

function processComponents(components) {
	const hasMultipleAdverts =
		components.filter((component) => component.component === 'advert')
			.length > 1;
	if (hasMultipleAdverts) {
		components = components.map((component) => {
			if (component.component === 'advert') {
				component.component = 'image';
			}

			return component;
		});
	}

	return [...components];
}
